export default "__VITE_ASSET__cbc_me3T__"